import { v4 as uuidv4 } from 'uuid';
import { create } from 'zustand';

import {
  DEFAULT_TOAST_CONFIG,
  SHOW_TOAST_AMOUNT,
  STATE_TRANSITION_DURATION,
} from '../constants';

import { State, ToastConfiguration } from './types';

/** Fill up incomplete config with default values */
const getCompleteConfiguration = (
  config: Partial<ToastConfiguration>
): ToastConfiguration => ({
  ...DEFAULT_TOAST_CONFIG,
  ...config,
  id: uuidv4(),
});

export const useToastStore = create<State>((set, get) => ({
  queue: [],

  initToast: (config: ToastConfiguration): void => {
    setTimeout(() => {
      return set((state: State) => {
        const newQueue = [...state.queue];

        if (newQueue.length >= SHOW_TOAST_AMOUNT) {
          newQueue.pop();
        }

        newQueue.push(config);

        return {
          queue: newQueue,
        };
      });
    }, config.delay);

    setTimeout(
      () => {
        set((state) => {
          const newQueue = [...state.queue].filter((c) => c.id !== config.id);

          return {
            queue: newQueue,
          };
        });
        // STATE_TRANSITION_DURATION * 2 because we animate a toast's entrance and exit
      },
      config.delay + config.duration + STATE_TRANSITION_DURATION * 2
    );
  },

  initToastBatch: (configs: ToastConfiguration[]): void => {
    const { initToast } = get();

    configs.forEach((config) => initToast(config));
  },

  fire: (
    config: Partial<ToastConfiguration> | Partial<ToastConfiguration>[]
  ): void => {
    const { initToast, initToastBatch } = get();

    if (Array.isArray(config)) {
      initToastBatch(config.map((config) => getCompleteConfiguration(config)));
    } else {
      initToast(getCompleteConfiguration(config));
    }
  },
}));
